function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.047 -0.046)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.547,2.992A4.554,4.554,0,1,0,12.1,7.546,4.56,4.56,0,0,0,7.547,2.992Zm0,8.1A3.544,3.544,0,1,1,11.09,7.546,3.547,3.547,0,0,1,7.547,11.09Z",
  transform: "translate(0)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,2.558a.5.5,0,0,0,.5-.5V.546a.5.5,0,1,0-1,0V2.058A.5.5,0,0,0,7.5,2.558Z",
  transform: "translate(0.046)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.5,12.442a.5.5,0,0,0-.5.5v1.512a.5.5,0,1,0,1,0V12.942A.5.5,0,0,0,7.5,12.442Z",
  transform: "translate(0.046 0.092)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.507,3.992a.5.5,0,0,0,.354-.146l1.113-1.113a.5.5,0,1,0-.707-.708L11.154,3.139a.5.5,0,0,0,.353.853Z",
  transform: "translate(0.093)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.138,11.154,2.026,12.267a.5.5,0,0,0,.707.707l1.112-1.113a.5.5,0,0,0-.707-.707Z",
  transform: "translate(0 0.092)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.454,7H12.943a.5.5,0,1,0,0,1h1.511a.5.5,0,1,0,0-1Z",
  transform: "translate(0.093 0.046)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.557,7.5a.5.5,0,0,0-.5-.5H.547a.5.5,0,0,0,0,1h1.51A.5.5,0,0,0,2.557,7.5Z",
  transform: "translate(0 0.046)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.861,11.154a.5.5,0,0,0-.707.707l1.113,1.113a.5.5,0,1,0,.707-.707Z",
  transform: "translate(0.093 0.092)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.138,3.846a.5.5,0,1,0,.707-.707L2.733,2.025a.5.5,0,0,0-.707.708Z"
}));

function SvgIcoThemeLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoThemeLight);
export default __webpack_public_path__ + "static/media/ico_theme-light.f2e6fb46.svg";
export { ForwardRef as ReactComponent };